module.exports = __webpack_public_path__ + "public/adminIcons/manageCurrencyIcon.svg?8474ff85";